class Interaction {

	constructor(interaction) {
		this.interaction = interaction;
	}
	
	setActive( active ) {
		this.interaction.setActive( active );
	}

}

export {
	Interaction
}